(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('rmsEnum', rmsEnumFilter);

    function rmsEnumFilter(RmsEnum) {
        return function(value, enumName) {
            if (!value) return '';
            return RmsEnum.get(enumName, value, '');
        };
    }
})();